<script>
export default {
  name: "Spinner",

  props: {
    size: {
      type: String,
      default: "20",
    },
  },

  methods: {
    getDotsStyle() {
      const size = `${this.size}px`;
      return {
        margin: "0 2px",
        width: size,
        height: size,
      };
    },
  },
};
</script>

<template lang="pug">
  .container
    .spinner
      .spinner__dot.spinner__dot--bounce1(:style="getDotsStyle()")
      .spinner__dot.spinner__dot--bounce2(:style="getDotsStyle()")
      .spinner__dot.spinner__dot--bounce3(:style="getDotsStyle()")
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;

  .spinner {
    // left: 50%;
    // position: absolute;
    // top: 50%;
    // transform: translate(-50%, -50%);

    &__dot {
      animation: spinner 1.4s ease-in-out 0s infinite both;
      background-color: $primary;
      border-radius: 100%;
      display: inline-block;
      height: 20px;
      width: 20px;

      &--bounce1 {
        animation-delay: -0.32s;
      }

      &--bounce2 {
        animation-delay: -0.16s;
      }
    }
  }
}
</style>
